import { ItemDTO } from '../types';
import { colors, maxCountOfBars } from '../config';

export const setRandomColor = (data: ItemDTO[]) => {
  return [...data].map((item, index) => {
    const color = colors[index % maxCountOfBars];
    return { ...item, ...color };
  });
};
